module.exports = __webpack_public_path__ + "static/media/HelveticaNeue-01.5bae8628.svg";